/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SmsProviderEnum {
    UcGBilisim = 'UcGBilisim',
    AsisBt = 'AsisBT',
    Erccell = 'Erccell'
}


export function SmsProviderEnumFromJSON(json: any): SmsProviderEnum {
    return SmsProviderEnumFromJSONTyped(json, false);
}

export function SmsProviderEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsProviderEnum {
    return json as SmsProviderEnum;
}

export function SmsProviderEnumToJSON(value?: SmsProviderEnum | null): any {
    return value as any;
}

